import React, { useState } from 'react';
import { PLATFORMS, GREEN, BLACK, GREEN_LIGHT } from '../constants';
import { Btn, TextInput } from '../components/UI';

export default function Logins({ ob, onUpdate }) {
  const [logins, setLogins] = useState(ob.logins || {});
  const [sel, setSel]       = useState('shopify');
  const P = PLATFORMS.find(p => p.id === sel);

  function setField(field, val) {
    setLogins(prev => ({ ...prev, [sel]: { ...prev[sel], [field]: val } }));
  }

  function submit() {
    const newDone = ob.completedSteps.includes('logins')
      ? ob.completedSteps
      : [...ob.completedSteps, 'logins'];
    onUpdate({ ...ob, logins, completedSteps: newDone });
  }

  return (
    <div>
      <div style={{ fontWeight: 800, fontSize: 17, marginBottom: 14 }}>Submit Logins</div>
      <div style={{ display: 'flex', gap: 10 }}>
        {/* Platform list */}
        <div style={{ width: 130, flexShrink: 0 }}>
          {PLATFORMS.map(p => {
            const done = p.fields.some(f => logins[p.id] && logins[p.id][f] && logins[p.id][f].trim());
            return (
              <div
                key={p.id} onClick={() => setSel(p.id)}
                style={{
                  padding: '7px 10px', borderRadius: 8, marginBottom: 3, cursor: 'pointer',
                  fontSize: 13, fontWeight: 600,
                  background: sel === p.id ? BLACK : done ? GREEN_LIGHT : '#fff',
                  border: `1.5px solid ${sel === p.id ? BLACK : done ? GREEN : '#e0e0d8'}`,
                  color: sel === p.id ? '#fff' : BLACK,
                }}
              >
                {p.label}
              </div>
            );
          })}
        </div>

        {/* Fields */}
        <div style={{ flex: 1, background: '#f8f8f6', borderRadius: 12, padding: '14px 16px' }}>
          <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 10, color: '#555' }}>{P.label}</div>
          {P.fields.map(f => (
            <TextInput
              key={f} label={f}
              type={f.toLowerCase().includes('password') ? 'password' : 'text'}
              value={(logins[sel] && logins[sel][f]) || ''}
              onChange={e => setField(f, e.target.value)}
              ph={f}
            />
          ))}
          <Btn onClick={submit}>Save and Submit</Btn>
        </div>
      </div>
      <div style={{ marginTop: 10, padding: '9px 13px', background: '#fff9e6', border: '1.5px solid #fde68a', borderRadius: 9, fontSize: 12, color: '#92400e' }}>
        Credentials are stored locally and only visible to your account manager.
      </div>
    </div>
  );
}
